import React, {useState, useEffect, useMemo} from "react";

import {
    Button,
    Flex,
    Form,
    theme,
} from "antd";
import {DeleteOutlined, ExclamationCircleOutlined, PlusOutlined} from "@ant-design/icons";

import "../IraPage/IraPage.css";
import ModalComponent from "../../components/ModalComponent/ModalComponent";

import "../../api/axiosInstance";
import {axiosInstance} from "../../api/axiosInstance";
import {toast} from "react-toastify";

import {useLocation} from "react-router-dom";
import dayjs from "dayjs";
import IraFilter from "../../components/Ira/IraFilter/IraFilter";
import IraTable from "../../components/Ira/IraTable/IraTable";
import IraForm from "../../components/Ira/IraForm/IraForm";
import IraPaymentForm from "../../components/Ira/IraPaymentForm/IraPaymentForm";
import IraPaymentModal from "../../components/Ira/IraPaymentModal/IraPaymentModal";
import iraItemForm from "../../components/Ira/IraItemForm/IraItemForm";

const IraPage = (props) => {
    const [mode, setMode] = useState("insert");
    const [activeKey, setActiveKey] = useState(["1", "2"]);

    const [filterForm] = Form.useForm();
    const [generalDataForm] = Form.useForm();
    const [iraItemForm] = Form.useForm();
    const [addPaymentForm] = Form.useForm();
    const [pdvDisabled, setPdvDisabled] = useState(false);

    const [generalFormInitialValues, setGeneralFormInitialValues] = useState({
        invoiceNumber: "",
        owner: {id: ""},
        company: {id: ""},
        investor: {id: ""},
        creationDate: dayjs(new Date()),
        creationTime: dayjs(new Date()),
        delivery: dayjs(new Date()),
        invoiceDueTime: 15,
        paymentType: {id: 1},
        taxLiabilityType: {id: 1},
        pdv: 25.00,
        remark: '',
        previousYearIRA: false
    });

    const [iraItemFormInitialValues, setIraItemFormInitialValues] = useState({
        items: [{
            projectId: '',
            jmId: 1,
            amount: 1,
            rebate: 0.00
        }]
    });
    const [iraItemFormErrors, setIraItemFormErrors] = useState([]);

    const [rowData, setRowData] = useState();

    const [loading, setLoading] = useState(false);

    const [iraModalOpened, setIraModalOpened] = useState(false);
    const [iraPaymentModalOpened, setIraPaymentModalOpened] = useState(false);
    const [iraAddPaymentModalOpened, setIraAddPaymentModalOpened] = useState(false);

    const [companyFieldDisabled, setCompanyFieldDisabled] = useState(true);

    const [tableData, setTableData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortFields, setSortFields] = useState({
            creationDateSort: null,
            priceWithoutPdvSort: null,
            priceWithPdvSort: null,
            pdvPriceSort: null,
            paymentPercentageSort: null,
            invoiceNumberSort: null
        });

    const [totalRows, setTotalRows] = useState(0);

    const [owners, setOwners] = useState([]);
    const [investors, setInvestors] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [taxLiabilityTypes, setTaxLiablityTypes] = useState([]);
    const [jm, setJm] = useState([]);

    const [projects, setProjects] = useState([]);

    const [payments, setPayments] = useState([]);

    const [forceUpdate, setForceUpdate] = useState(false);

    const {token} = theme.useToken();

    let routeState = useLocation();

    const pageStyle = {
        maxWidth: "none",
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
        height: "100%",
    };

    const fetchIras = async (values, tPageNumber, tPageSize) => {
        try {
            const response = await axiosInstance.post(
                `/api/v1/ira/find-by?page=${tPageNumber - 1}&size=${tPageSize}`,
                {
                    ownerId: values?.ownerId,
                    investorId: values?.investorId,
                    companyId: values?.companyId,
                    statusId: values?.statusId,
                    dateFrom: values?.dateFrom ? dayjs(values?.dateFrom).startOf('day').format('YYYY-MM-DD') : null,
                    dateTo: values?.dateTo ? dayjs(values?.dateTo).startOf('day').format('YYYY-MM-DD') : null,
                    creationDateSort: values?.creationDateSort ? values.creationDateSort : null,
                    debtorSort: values?.paymentPercentageSort ? values.paymentPercentageSort : null,
                    priceWithoutPdvSort: values?.priceWithoutPdvSort ? values.priceWithoutPdvSort : null,
                    priceWithPdvSort: values?.priceWithPdvSort ? values.priceWithPdvSort : null,
                    pdvPriceSort: values?.pdvPriceSort ? values.pdvPriceSort : null,
                    invoiceNumberSort: values?.invoiceNumberSort ? values.invoiceNumberSort : null,
                }
            );

            setTableData(
                response?.data?.content.map((element) => {
                    return {
                        ...element,
                        key: element.id,
                    };
                })
            );
            setTotalRows(response?.data?.totalElements);
        } catch (ex) {
            console.log('Error while calling fetchIras().')
        }

    };


    const fetchCodebooks = async () => {
        fetchIras(null, 1, pageSize);
        fetchStatuses();
        fetchPaymentTypes();
        fetchJm();
        Promise.all([fetchOwners(), fetchInvestors(), fetchProjects(), fetchCompanies(), fetchTaxLiabilityTypes()]);
    };


    useEffect(() => {
        fetchCodebooks()
    }, [])

        useEffect(() => {
            console.log({...filterForm.getFieldsValue(), ...sortFields}, 'juihu')
            fetchIras({...filterForm.getFieldsValue(), ...sortFields}, pageNumber, pageSize);
        }, [sortFields])

    const fetchOwners = (values) => {
        return axiosInstance.get(`/api/v1/users/find-all`).then(res => {
            const data = res.data.map((x) => {
                return {value: x.id, label: `${x.firstName} ${x.lastName}`, jobTitle: x.jobTitle};
            });
            setOwners([{
                value: "",
                label: "Prikaži sve"
            }].concat(data.filter(x => x.jobTitle === 'direktor')))
        }).catch(ex => {
            console.log('Error while calling fetchUsers().')
        });
    };
    const fetchInvestors = () => {
        return axiosInstance.get("/api/v1/investors/find-all")
            .then(res => {
                const data = res.data.map((x) => {
                    return {value: x.id, label: x.name};
                });
                setInvestors([{value: "", label: "Prikaži sve"}].concat(data));
            }).catch(ex => {
                console.log('Error while calling fetchInvestors().')
            })
    };

    const fetchProjects = (investorId) => {

        let tInvestorId = null;
        if (mode === 'edit') {
            console.log(rowData?.investor?.id, 'investore')
            tInvestorId = investorId ? investorId : rowData?.investor?.id;
        } else {
            tInvestorId = investorId;
        }

        let url = `/api/v1/projects/find-all`

        return axiosInstance.get(url).then(res => {
            const data = res.data.map((x) => {
                return {value: x.id, label: `${x.name} - ${x?.investor?.name}`, price: x.price};
            });
            setProjects([{value: "", label: "Prikaži sve"}].concat(data));
        }).catch(ex => {
            console.log('Error while calling fetchProjects().')
        });
    };

    const fetchCompanies = (values) => {
        return axiosInstance.get(`/api/v1/companies/find-all`).then(res => {
            const data = res.data.map((x) => {
                return {value: x.id, label: `${x.name}`};
            });
            setCompanies([{value: "", label: "Prikaži sve"}].concat(data));
        }).catch(ex => {
            console.log('Error while calling fetchCompanies().')
        });
    };

    /*    const fetchCompaniesByOwnerId = (ownerId) => {
            return axiosInstance.get(`/api/v1/companies/find-by-owner-id/${ownerId}`).then(res => {
                const data = res.data.map((x) => {
                    return {value: x.id, label: `${x.name}`};
                });
                setCompanies([{value: "", label: "Prikaži sve"}].concat(data));
            }).catch(ex => {
                console.log('Error while calling fetchCompanies().')
            });
        };*/

    const fetchStatuses = (values) => {
        setStatuses([{value: "", label: "Prikaži sve"}, {value: 1, label: "Otvoren"}, {
            value: 2,
            label: "Zatvoren"
        }, {value: 3, label: "Storniran"}]);
    };

    const fetchPaymentTypes = (values) => {
        setPaymentTypes([{value: 1, label: "Transakcijski"}]);
    };

    const fetchJm = (values) => {
        setJm([{value: "", label: "Prikaži sve"}, {value: 1, label: "kom"}]);
    };

    const fetchTaxLiabilityTypes = (values) => {
        return axiosInstance.get(`/api/v1/tax-liability-types`).then(res => {
            const data = res.data.map((x) => {
                return {value: x.id, label: `${x.name}`};
            });
            setTaxLiablityTypes(data);
        }).catch(ex => {
            console.log('Error while calling fetchTaxLiabilityTypes().')
        });
    };

    const fetchPayments = (id) => {
        return axiosInstance.get(`/api/v1/ira/${id}/payments`).then(res => {
            setPayments(res.data);
        }).catch(ex => {
            console.log('Error while calling fetchPayments().')
        });
    };
    const fetchIraItems = async (id) => {
        try {
            const res = await axiosInstance.get(`api/v1/ira/items/${id}`)
            if (res) {
                setIraItemFormInitialValues({items: res.data});
                iraItemForm.resetFields();
            }
        } catch (ex) {
            console.log('Error while calling fetchIraItems().')
        }
    }
    const generalDataFormTitle = () => {
        if (mode === "insert") {
            return "Novi izlazni račun";
        } else if (mode === "edit") {
            return "Uređivanje izlaznog računa";
        } else {
            return "Pregled izlaznog računa";
        }
    };

    const onIraSubmit = ({generalData}) => {

        const mappedValues = {
            ...generalData,
            id: rowData?.id,
            creationDate: dayjs(generalData.creationDate).startOf('day').format('YYYY-MM-DD'),
            creationTime: dayjs(generalData.creationTime).format("HH:mm"),
            delivery: dayjs(generalData.delivery).startOf('day').format('YYYY-MM-DD'),
            owner: {...generalData.owner, id: generalData?.owner?.id},
            company: {...generalData.company, id: generalData?.company?.id},
            investor: {...generalData.investor, id: generalData?.investor?.id},
            paymentType: {...generalData.paymentType, id: generalData?.paymentType?.id},
            taxLiabilityType: {...generalData.taxLiabilityType, id: generalData?.taxLiabilityType?.id},
            items: iraItemForm.getFieldsValue().items
        };

        console.log(mappedValues, 'mappedValues')

        if (mode === "insert") {

            axiosInstance
                .post("/api/v1/ira", mappedValues)
                .then((res) => {
                    setLoading(false);
                    setIraModalOpened(false);
                    iraItemForm.resetFields();
                    generalDataForm.resetFields();
                    //setCompanies([{value: "", label: "Prikaži sve"}]);
                    toast.success("Račun uspješno spremljen!");
                    const initialValues = {
                        ownerId: null,
                        investorId: null,
                        companyId: null,
                        statusId: null,
                        dateFrom: null,
                        dateTo: null
                    };
                    fetchIras({...initialValues, ...sortFields}, 1, pageSize)
                })
                .catch((ex) => {
                    console.log(ex, "ex");
                    toast.error("Došlo je do greške prilikom spremanja računa!");
                });
        } else if (mode === "edit") {


            axiosInstance
                .patch(`/api/v1/ira`, mappedValues)
                .then((res) => {
                    setLoading(false);
                    setIraModalOpened(false);
                    filterForm.resetFields();
                    generalDataForm.resetFields();
                    iraItemForm.resetFields();
                    toast.success("Račun uspješno ažuriran!");
                    if (Number(res.data.paymentPercentage) > 100.00) {
                        toast.info("Iznos uplata veći je od iznosa računa!")
                    }
                    const initialValues = {
                        ownerId: null,
                        investorId: null,
                        companyId: null,
                        statusId: null,
                        dateFrom: null,
                        dateTo: null
                    };
                    fetchIras({...initialValues, ...sortFields}, 1, pageSize)
                })
                .catch((ex) => {
                    toast.error("Došlo je do greške prilikom ažuriranja računa. " + ex.response.data.errorMessage);
                });
        }
    };

    const handleSubmitProject = async () => {
        let validationResultGeneralForm;
        let validationResultIraItemForm;

        let tGeneralFormHasErrors = false;
        let tIraItemFormHasErrors = false;

        try {
            validationResultGeneralForm = await generalDataForm.validateFields();
            if (!validationResultGeneralForm.errorFields) {
                generalDataForm.submit();
                //setLoading(true);
            }
        } catch (ex) {
            console.log(ex);
            tGeneralFormHasErrors = true;
        }

        try {
            validationResultIraItemForm = await iraItemForm.validateFields();
            if (!validationResultIraItemForm.errorFields) {
                iraItemForm.submit();
                //setLoading(true);
            }
        } catch (ex) {
            console.log(ex, 'aaaa');
            setIraItemFormErrors(ex.errorFields)
            tIraItemFormHasErrors = true;
        }

        const iraItemFormValues = iraItemForm.getFieldsValue()?.items;

        console.log(iraItemFormValues, 'iraItemValues')

        if (tGeneralFormHasErrors || tIraItemFormHasErrors || iraItemFormValues?.length === 0) {
            if (iraItemFormValues?.length === 0) {
                toast.error("Račun nema niti jednu stavku.");
            }
        } else {
            onIraSubmit({
                generalData: generalDataForm.getFieldsValue(),
            });
        }
    };

    const onFormFilterSubmit = async (values) => {
        setPageNumber(1);
        fetchIras({...values, ...sortFields}, 1, pageSize);
    };

    const handleFieldsChange = async (formName, changedValues, allValues) => {
        if (formName === 'generalDataForm') {
            if (!allValues.owner.id) {
                setCompanyFieldDisabled(true);
            } else {
                setCompanyFieldDisabled(false);
            }

            /*         if(changedValues?.owner?.id){
                         fetchCompaniesByOwnerId(changedValues.owner.id);
                         generalDataForm.setFieldsValue({company: {id: ''}})
                     }*/
        }
    }
    const onFilterChanged = async (pagination, filters, sorter, action) => {

        if (action === 'paginate') {
            console.log(pagination, 'pagination')
            setPageNumber(pagination.current);
            setPageSize(pagination.pageSize);
            fetchIras({...filterForm.getFieldsValue(), ...sortFields}, pagination.current, pagination.pageSize)

        } else if (action === 'sort') {

            console.log(sorter, 'sorter')
            let sortField = null;
            let sortFieldValue = null;

            const returnSortFieldValue = (sorterOrder) => {
                switch (sorterOrder) {
                    case 'descend' :
                        return 'DESC';
                        case 'ascend' :
                            return 'ASC';
                    default:
                        return null;
                }
            };

            if (sorter?.columnKey === 'creationDate') {
                sortField = 'creationDateSort';
                const returnedValue = returnSortFieldValue(sorter.order);
                sortFieldValue = returnedValue === 'DESC' ? 'NEWEST' : 'OLDEST';
            }
            if (sorter?.columnKey === 'priceWithoutPdv') {
                sortField = 'priceWithoutPdvSort';
                sortFieldValue = returnSortFieldValue(sorter.order);
            }
            if (sorter?.columnKey === 'priceWithPdv') {
                sortField = 'priceWithPdvSort';
                sortFieldValue = returnSortFieldValue(sorter.order);
            }
            if (sorter?.columnKey === 'pdvPrice') {
                sortField = 'pdvPriceSort';
                sortFieldValue = returnSortFieldValue(sorter.order);
            }
            if (sorter?.columnKey === 'paymentPercentage') {
                sortField = 'paymentPercentageSort';
                const returnedValue = returnSortFieldValue(sorter.order);
                sortFieldValue = returnedValue === 'DESC' ? 'SMALLEST' : 'BIGGEST';

            }
            if (sorter?.columnKey === 'invoiceNumber') {
                sortField = 'invoiceNumberSort';
                sortFieldValue = returnSortFieldValue(sorter.order);
            }

            console.log({...sortFields, [sortField]: sortFieldValue}, 'asdasdasd')
            setSortFields({[sortField]: sortFieldValue});
        }
    };

return (
    <div className={"ira-page"} style={pageStyle}>
        <h3>Izlazni računi</h3>
        <IraFilter
            form={filterForm}
            owners={owners}
            investors={investors}
            companies={companies}
            statuses={statuses}
            onFormFilterSubmit={onFormFilterSubmit}
        ></IraFilter>
        <Flex vertical={false} justify="right" className="add-ira-wrapper">
            <Button
                disabled={props?.userData?.authorities?.includes('ROLE_ZAPOSLENIK')}
                type="dashed"
                icon={<PlusOutlined/>}
                style={{marginTop: "32px"}}
                onClick={() => {
                    setIraItemFormInitialValues({items: [{projectId: '', jmId: 1, amount: 1, rebate: 0.00}]})
                    generalDataForm.resetFields();
                    iraItemForm.resetFields();
                    setPdvDisabled(false);
                    setIraItemFormErrors([]);
                    setProjects([])
                    setMode("insert");
                    setRowData(null);
                    setIraModalOpened(true);
                }}
            >
                Kreiraj izlazni račun
            </Button>
        </Flex>
        <IraTable
            mode={mode}
            setMode={setMode}
            setRowData={setRowData}
            totalRows={totalRows}
            pageNumber={pageNumber}
            pageSize={pageSize}
            setIraModalOpened={setIraModalOpened}
            tableData={tableData}
            setIraPaymentModalOpened={setIraPaymentModalOpened}
            fetchPayments={(id) => fetchPayments(id)}
            fetchIraItems={(id) => fetchIraItems(id)}
            //fetchCompaniesByOwnerId={(ownerId) => fetchCompaniesByOwnerId(ownerId)}
            onFilterChanged={(pagination, filters, sorter, action) => onFilterChanged(pagination, filters, sorter, action)}
            refreshData={() => {
                const initialValues = {
                    ownerId: null,
                    investorId: null,
                    companyId: null,
                    statusId: null,
                    dateFrom: null,
                    dateTo: null
                };
                fetchIras({...initialValues, ...sortFields}, 1, pageSize)
            }}
            fetchProjects={(investorId) => fetchProjects(investorId)}
        />
        <ModalComponent
            title={generalDataFormTitle()}
            show={iraModalOpened}
            onOk={handleSubmitProject}
            onCancel={() => {
                generalDataForm.resetFields();
                iraItemForm.resetFields();
                setCompanyFieldDisabled(true);
                setIraItemFormInitialValues({
                    items: [{
                        projectId: '',
                        jmId: 1,
                        amount: 1,
                        rebate: 0.00
                    }]
                })
                setRowData(null);
                setIraModalOpened(false);
            }}
            loading={loading}
            showFooter={mode !== "preview"}
            width={"800px"}
        >
            <IraForm
                mode={mode}
                owners={owners}
                companies={companies}
                investors={investors}
                projects={projects}
                paymentTypes={paymentTypes}
                taxLiabilityTypes={taxLiabilityTypes}
                jm={jm}
                generalDataForm={generalDataForm}
                iraItemForm={iraItemForm}
                rowData={rowData}
                userData={props?.userData}
                initialValues={
                    mode === "insert" ? generalFormInitialValues : rowData
                }
                iraItemFormInitialValues={
                    iraItemFormInitialValues
                }
                handleFieldsChange={(formName, changedValues, allValues) => handleFieldsChange(formName, changedValues, allValues)}
                activeKey={activeKey}
                setActiveKey={setActiveKey}
                iraItemFormErrors={iraItemFormErrors}
                setIraItemFormErrors={setIraItemFormErrors}
                companyFieldDisabled={companyFieldDisabled}
                forceUpdate={forceUpdate}
                fetchProjects={(investorId) => fetchProjects(investorId)}
                pdvDisabled={pdvDisabled}
                setPdvDisabled={setPdvDisabled}

            ></IraForm>
        </ModalComponent>
        <IraPaymentModal
            iraPaymentModalOpened={iraPaymentModalOpened}
            setIraPaymentModalOpened={setIraPaymentModalOpened}
            setIraAddPaymentModalOpened={setIraAddPaymentModalOpened}
            loading={loading}
            mode={mode}
            payments={payments}
            fetchPayments={(id) => fetchPayments(id)}
            fetchIras={() => {
                const initialValues = {
                    ownerId: null,
                    investorId: null,
                    companyId: null,
                    statusId: null,
                    dateFrom: null,
                    dateTo: null
                };
                fetchIras({...initialValues, ...sortFields}, 1, pageSize)
            }}
        />

        <IraPaymentForm
            addPaymentForm={addPaymentForm}
            iraAddPaymentModalOpened={iraAddPaymentModalOpened}
            setIraAddPaymentModalOpened={setIraAddPaymentModalOpened}
            rowData={rowData}
            fetchPayments={(id) => fetchPayments(id)}
            fetchIras={() => {
                const initialValues = {
                    ownerId: null,
                    investorId: null,
                    companyId: null,
                    statusId: null,
                    dateFrom: null,
                    dateTo: null
                };
                fetchIras({...initialValues, ...sortFields}, 1, pageSize)
            }}
            loading={loading}
            mode={mode}
        />
    </div>);
}
;

export default IraPage;
